import React from "react";
import { Route, Routes } from "react-router-dom";
import ProgramacionEquipoPage from "../pages/ProgramacionEquipoPage";

export default function ProgramacionEquipoRoutes() {
  return (
    <Routes>
      <Route path="" element={<ProgramacionEquipoPage />} />
    </Routes>
  );
}
